import { render, staticRenderFns } from "./RELVelocidade.vue?vue&type=template&id=7e2570a2&"
import script from "./RELVelocidade.vue?vue&type=script&lang=js&"
export * from "./RELVelocidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports